import { createSlice } from "@reduxjs/toolkit";
import { FollowedStoresState } from "./followed-stores.state";
import { getFollowedStores } from "./followed-stores.thunk";

const initialState: FollowedStoresState = {
  data: null,
  status: "idle",
  error: null,
  currentPage: 1,
  hasMore: true,
};

export const followedStoresSlice = createSlice({
  name: "followedStores",
  initialState,
  reducers: {
    resetFollowedStores: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.currentPage = 1;
      state.hasMore = true;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFollowedStores.pending, (state, action) => {
        const isFirstPage = !action.meta.arg || action.meta.arg.page === 1;
        
        if (isFirstPage) {
          state.data = null;
        }
        
        state.status = "loading";
        state.error = null;
      })
      .addCase(getFollowedStores.fulfilled, (state, action) => {
        state.status = "success";
        
        const responseData = action.payload.data;
        const currentPage = responseData.pagination.current_page;
        
        // If it's page 1, replace data. Otherwise, append to existing data
        if (currentPage === 1) {
          state.data = responseData;
        } else if (state.data) {
          // Append new items to existing items
          state.data = {
            ...responseData,
            items: [...state.data.items, ...responseData.items],
            pagination: responseData.pagination,
          };
        } else {
          state.data = responseData;
        }
        
        state.currentPage = currentPage;
        state.hasMore = responseData.pagination.next_page_url !== null;
      })
      .addCase(getFollowedStores.rejected, (state, action) => {
        state.status = "error";
        state.error =
          action.payload ?? "Mağazalar yüklenirken bir hata oluştu.";
      });
  },
});

export const { resetFollowedStores, setCurrentPage } = followedStoresSlice.actions;

export default followedStoresSlice.reducer;